module.exports = {
  "country": "NO",
  "artist": "Margaret Berger",
  "song": "I Feed You My Love",
  "year": "2013",
  "place": "4",
  "spotify": ""
};